import CAJA1010ResponseModel from '@/api/data/CAJ/CAJG1010/CAJA1010ResponseModel'
import ApiUrlConstants from '../../../common/ApiUrlConstants'
import RestService from '../../../common/RestService'

export default class CAJG1010Service {
  /**
   * 「caja1010RequestModel」APIのリクエストを初期化する。
   * @returns string base 64
   */
  public async callAPICAJA1010(): Promise<CAJA1010ResponseModel> {
    const caja1010ResponseModel: CAJA1010ResponseModel = <
      CAJA1010ResponseModel
    > await RestService.post(ApiUrlConstants.CAJA1010, {})
    return caja1010ResponseModel
  }
}
